import React, { useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  CustomSelectComponent,
  FieldInput,
  FieldLabel,
  FieldNumericInput,
  FieldTextArea,
  FormCol,
  FormRow,
} from 'motion-components';
import { isActiveField } from 'shared-pages/common/form-helpfunc';
import {
  notificationResponseTypeLabel,
  notificationTypeOptions,
  NotificationStatus,
} from '../constants';
import { NotificationStatusBadge } from '../notification-status-badge';

type FormValues = {
  name: string;
  typeCode: string;
  responseType: string;
  statusId: number;
  tokenTtlDays: number;
  notes: string;
  isActive: boolean;
};

export const FormFields = ({ canEdit, isNew }: { canEdit: boolean; isNew: boolean }) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<FormValues>();
  const isDraft = isNew || values.statusId === NotificationStatus.Draft;

  // Ο τύπος απάντησης ακολουθεί τον κωδικό προτύπου — δεν τον διαλέγει ο χρήστης
  useEffect(() => {
    const opt = notificationTypeOptions.find((o) => o.value === values.typeCode);
    if (opt && values.responseType !== opt.responseType) {
      setFieldValue('responseType', opt.responseType);
    }
  }, [values.typeCode, values.responseType, setFieldValue]);

  return (
    <FormRow>
      <FormCol>
        <FieldInput label={t('Όνομα')} name="name" placeholder="" disabled={!canEdit} />
        {/* Το Formik απορροφά το as — περνάμε as="div" ώστε να μην μπει δεύτερο FormCol (padding + στενό πλάτος) */}
        <Field
          className="mb-2"
          name="typeCode"
          title={t('Τύπος ενημέρωσης')}
          component={(props) => <CustomSelectComponent {...props} as="div" />}
          options={notificationTypeOptions}
          disabled={!canEdit || !isDraft}
        />

        <Form.Group as="div" className="mb-2">
          <FieldLabel text={t('Τύπος απάντησης')} />
          <div>{t(notificationResponseTypeLabel(values.responseType)) || '-'}</div>
        </Form.Group>
      </FormCol>
      <FormCol>
        <FieldNumericInput
          label={t('Ημέρες ισχύος token')}
          name="tokenTtlDays"
          min="1"
          step="1"
          // Οι ημέρες token ισχύουν στη σύνθεση/αποστολή — μετά παγώνουν
          disabled={!canEdit || !isDraft}
        />
        <FieldTextArea label={t('Σημειώσεις')} name="notes" disabled={!canEdit} rows={4} />
      </FormCol>
      <FormCol>
        <div className="d-flex flex-column align-items-start mb-2">
          <span className="mb-1">{t('Κατάσταση :')}</span>
          <NotificationStatusBadge statusId={values.statusId} />
        </div>
        {isActiveField(t, canEdit)}
      </FormCol>
    </FormRow>
  );
};
